{
  "collect": "采集标本",
  "track": "追踪标本",
  "accession": "接收编号",
  "barcode": "条形码",
  "status": {
    "ordered": "已开单",
    "collected": "已采集",
    "inTransit": "运送中",
    "received": "已接收",
    "processing": "检测中",
    "resulted": "已出结果",
    "rejected": "已拒收",
    "in_transit": "运送中"
  },
  "title": "标本",
  "loading": "正在加载标本…",
  "errorState": "无法加载标本。",
  "emptyState": "该患者暂无标本。",
  "noRejectionReason": "已拒收——未记录原因",
  "columns": {
    "accession": "标本号",
    "type": "类型",
    "status": "状态",
    "collected": "采集时间",
    "received": "接收时间",
    "location": "当前位置"
  }
}
